import { AxiosResponse } from 'axios'
import { apiClient, apiWebClient } from '@/services/client'
import ApiConfig from '@/services/api.config'
import { Stream } from '@/services/api.types'

export default async function fetchStream(channelId: string, web?: boolean): Promise<AxiosResponse<Stream>> {
  return (web ? apiWebClient : apiClient).get(`${ApiConfig.NOW_PLAYING}/${channelId}`)
}
